import { store } from 'app/redux/store';
import { IClientBusiness } from 'app/services/responseTypes';
import {
  initialState,
  TSelfEmploymentList,
  updateFieldArrayKey,
  updateKey,
} from '../edit/TaxQuestionnaire/Income/SelfEmployment/slice';

export default function autoFillSelfEmploymentSlice(
  businesses: IClientBusiness[],
) {
  store.dispatch(updateKey({ key: 'selfEmploymentList', value: [] }));

  const toFill: TSelfEmploymentList = [];
  businesses?.forEach((business) => {
    toFill.push({
      ...initialState.values.selfEmploymentList[0],
      businessName: business.name,
      businessAddress: business.address || null,
      whatIsTheBusinessStructure: business.business_type,
      primaryServiceThatTheBusinessProvides:
        business.specialization?.name || null,
    });
  });

  store.dispatch(
    updateFieldArrayKey({ key: 'selfEmploymentList', value: toFill }),
  );
}
